interface StatsCardProps {
  title: string;
  value: string | number;
  className?: string;
}

export const StatsCard = ({ title, value, className }: StatsCardProps) => {
  return (
    <div className={`rounded-lg border border-border bg-card p-6 ${className}`}>
      <p className="mb-2 text-sm text-muted-foreground">{title}</p>
      <p className="text-3xl font-bold text-foreground">{value}</p>
    </div>
  );
};
